import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { MmuTitleService } from '../service/mmu-title.service';

@Component({
  selector: 'mmu-view-title',
  template: '<ng-container>{{ title$ | async }}</ng-container>',
  styles: [':host { display: inline }']
})
export class MmuViewTitleComponent {

  readonly title$: Observable<string>;

  constructor(private ts: MmuTitleService) {
    this.title$ = ts.title;
  }
}
